import { useEffect, useState } from "react";

import { getArrowDownIcon } from "../services/icons";
import { DropdownSelectValuesType, FilterValueUpdateType } from "../types";

type PropsType = {
  label: string;
  defaultValue: string;
  value?: string;
  name: string;
  values: DropdownSelectValuesType;
  border?: boolean;
  onUpdate: FilterValueUpdateType;
};

export default function Dropdown({
  label,
  defaultValue,
  value,
  values,
  border = true,
  name,
  onUpdate,
}: PropsType) {
  const [val, setVal] = useState(value ? value : defaultValue);
  const [selected, setSelected] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  // useEffect(() => {
  //   if (!val || val === defaultValue) {
  //     return;
  //   }
  //   onUpdate(name, val);
  // }, [val]);

  // useEffect(() => {
  //   setSelected(val !== defaultValue);
  // }, [val]);

  useEffect(() => {
    setSelected(val !== defaultValue);
  }, [defaultValue, val]);

  const onValueUpdate = (v: string) => {
    setVal(v);
    onUpdate(name, v);
    setShowDropdown(!showDropdown);
  };

  let theme = "bg-transparent text-theme-grey-7 border-[#eeeeee]";
  let valueTheme = "text-black";
  let iconTheme = "#000000";
  if (selected) {
    theme = "bg-[#000000] text-theme-grey-7";
    valueTheme = "text-[#FFFFFF]";
    iconTheme = "#FFFFFF";
  }
  if (selected && showDropdown) {
    valueTheme = "text-black";
  }

  return (
    <div
      id="wrp"
      className={`${theme} relative inline-block min-w-[140px] px-[12px] py-[8px] text-[14px] text-theme-grey-7 ${
        border && "border-[1px]"
      } ${showDropdown ? "rounded-t-[4px] !bg-white drop-shadow-card" : "rounded-[4px]"}`}
    >
      <div
        className="relative flex cursor-pointer flex-row items-center justify-between gap-1"
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <div className="flex flex-row items-center gap-1 leading-none">
          {label}
          <div className={`font-semibold capitalize ${valueTheme}`}>
            {values.find((v) => v.value === val)?.title}
          </div>
        </div>
        <div className={`ml-1 transition-all ${showDropdown && "rotate-180"}`}>
          {getArrowDownIcon(iconTheme)}
        </div>
      </div>
      {showDropdown && (
        <div
          className={`${theme} absolute z-10 ml-[-13px] mt-2 w-[calc(100%+2px)] rounded-b-[4px] border-l-[1px] border-r-[1px] px-[12px] py-[8px] ${
            showDropdown && "!bg-white"
          }`}
        >
          {values.map((val, index) => {
            return (
              <div
                className={`cursor-pointer capitalize transition ${
                  selected && border ? "hover:text-[#dfdfdf]" : "hover:text-black"
                } `}
                key={index}
                onClick={() => onValueUpdate(val.value)}
              >
                {val.title}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
